import { useEffect, useState } from "react";

import { CodatLinkProps } from "@codat/sdk-link-types";
import config from "config";
import styles from "./LinkSDK.module.scss";

type ExtendedCodatLinkPropsProps = CodatLinkProps & {
  baseUrl: string;
  codatLinkMode: "hosted";
};

const initializeCodatLink = (
  sdkUrl: string,
  target: HTMLElement,
  props: CodatLinkProps
): Promise<void> => {
  return import(/* webpackIgnore: true */ sdkUrl).then(({ CodatLink }) => {
    new CodatLink({
      target,
      props,
    });
  });
};

export const CodatLink = (props: CodatLinkProps) => {
  const [componentMount, setComponentMount] = useState<HTMLDivElement | null>(
    null
  );

  const baseUrl = config.LINK_API_URL;
  const codatLinkMode = "hosted";
  const extendedProps: ExtendedCodatLinkPropsProps = {
    ...props,
    baseUrl,
    codatLinkMode,
  };

  useEffect(() => {
    const target = componentMount;
    if (target && target.children.length === 0) {
      initializeCodatLink(config.LINK_SDK_URL, target, extendedProps);
    }
    // CodatLink does not support changing props after initialisation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [componentMount]);

  return <div className={styles.codatLink} ref={setComponentMount}></div>;
};
